const masqueradeKey = 'RAYDIANT_MASQUERADE_USER';

export const getMasqueradeUser = () => {
  return localStorage.getItem(masqueradeKey);
};

export const setMasqueradeUser = (email: string) => {
  return localStorage.setItem(masqueradeKey, email);
};
